<script lang="ts">
	import Description from '$lib/components/SEO/Description.svelte';
	import Title from '$lib/components/SEO/Title.svelte';
	import TransferHomeCreditSimulation from '$lib/components/Simulations/Components/Products/TransferHomeCreditSimulation.svelte';
	import __ from '$lib/stores/TranslationStore';
</script>

<svelte:head>
	<Title
		content={$__(
			'Simulador de Crédito Habitação: Encontre a Melhor Solução com Poupança no Minuto'
		)}
	/>
	<Description
		content={$__(
			'Descubra como reduzir as suas mensalidades e poupar no seu crédito habitação atual com o nosso simulador de transferência. A Poupança no Minuto facilita a comparação de ofertas para que encontre a opção mais vantajosa. Transforme o seu crédito habitação e economize já.'
		)}
	/>
</svelte:head>

<TransferHomeCreditSimulation />
